import { render, staticRenderFns } from "./ExportNotification.vue?vue&type=template&id=537e57bc&scoped=true&"
import script from "./ExportNotification.vue?vue&type=script&lang=js&"
export * from "./ExportNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e57bc",
  null
  
)

export default component.exports